import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { subscribeToCheckoutVisibility } from "@/lib/checkoutOverlay";
import GuardianDonationWidget from "@/components/donation/GuardianDonationWidget";

export function StickyMobileCta() {
  const [pastHero, setPastHero] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => setKeyboardOpen(vv.height < window.innerHeight * 0.75);
    vv.addEventListener("resize", onResize);
    return () => vv.removeEventListener("resize", onResize);
  }, []);

  useEffect(
    () => subscribeToCheckoutVisibility(() => setCheckoutOpen(true), () => setCheckoutOpen(false)),
    []
  );

  if (checkoutOpen) return null;

  const visible = pastHero && !keyboardOpen;

  return (
    <>
      <div
        className={`md:hidden fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-2 transition-transform duration-300 ${
          visible ? "translate-y-0" : "translate-y-full"
        }`}
        data-testid="landing-sticky-mobile-cta"
      >
        <Button
          size="lg"
          onClick={() => setDialogOpen(true)}
          className="w-full h-[52px] rounded-full bg-amtm-give text-amtm-giveText hover:bg-amtm-giveHover shadow-2xl font-semibold"
          data-testid="landing-sticky-mobile-cta-button"
        >
          <Heart className="h-5 w-5 mr-2" /> Become a Guardian
        </Button>
      </div>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent data-testid="guardian-sticky-dialog" className="rounded-2xl max-h-[90vh] overflow-y-auto p-0 border-0 bg-transparent shadow-none">
          <DialogHeader className="sr-only">
            <DialogTitle>Become a Guardian</DialogTitle>
          </DialogHeader>
          <GuardianDonationWidget testIdPrefix="guardian-sticky" onBeforeCheckout={() => setDialogOpen(false)} onCheckoutCancelled={() => setDialogOpen(true)} />
        </DialogContent>
      </Dialog>
    </>
  );
}

